// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/emodel/v1/common_model.proto (package devtool.emodel.v1, syntax proto3)
/* eslint-disable */

// A verbatim mirror of eModel's common_model.proto (enechain/service-proto,
// services/emodel/emodel/v1), in a package this repository owns: eposition-app's
// protos do not import another service's protos, but the dev-tool RPCs carry
// eModel requests and responses as their own.
//
// Field numbers and types match emodel.v1 exactly. That is what lets
// devtoolemodel.Convert translate by re-encoding instead of copying field by
// field, so any change to eModel's messages has to be mirrored here by hand —
// TestMirrorMatchesEmodel fails if the two ever drift.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/emodel/v1/common_model.proto.
 */
export const file_devtool_emodel_v1_common_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate]);

/**
 * CollateralConfig controls collateral (VM) simulation (post-process) similar to backend/app pnlcalc.
 * Default behavior is disabled (no collateral).
 *
 * @generated from message devtool.emodel.v1.CollateralConfig
 */
export type CollateralConfig = Message<"devtool.emodel.v1.CollateralConfig"> & {
  /**
   * If true, apply collateral post-process to the aggregated portfolio PnL/NPV matrix.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * Threshold for margin call (same unit as NPV/CF, e.g. JPY).
   * Not used by the BILATERAL model (Version 9.1 has no threshold gate).
   *
   * @generated from field: int64 threshold = 2;
   */
  threshold: bigint;

  /**
   * Current collateral amount at t=0 (Day0).
   *
   * @generated from field: double current_collateral = 3;
   */
  currentCollateral: number;

  /**
   * Margin call frequency (business-day aware; weekends treated as holidays).
   *
   * @generated from field: devtool.emodel.v1.Frequency margin_call_frequency = 4;
   */
  marginCallFrequency: Frequency;

  /**
   * Payment lag in calendar days for collateral settlement (optional, default: 0).
   *
   * @generated from field: optional int32 payment_lag_days = 5;
   */
  paymentLagDays?: number;

  /**
   * Business day convention applied to payment due dates.
   *
   * @generated from field: devtool.emodel.v1.BusinessDayConvention payment_convention = 6;
   */
  paymentConvention: BusinessDayConvention;

  /**
   * Calendar for business day adjustment (v0 uses weekends only).
   *
   * @generated from field: devtool.emodel.v1.Calendar payment_calendar = 7;
   */
  paymentCalendar: Calendar;

  /**
   * Weekday for margin call evaluation (1=Monday .. 5=Friday).
   * Required when margin_call_frequency is WEEKLY or BIWEEKLY.
   *
   * @generated from field: optional int32 margin_call_weekday = 8;
   */
  marginCallWeekday?: number;

  /**
   * Pre-computed margin call timing map (day_tenor -> is_margin_call_day).
   * When provided, overrides margin_call_frequency/margin_call_weekday for margin call day determination.
   * This allows callers to pass organization-specific scheduling that accounts for
   * period-based frequency changes (e.g., switching from Daily to Biweekly mid-term).
   *
   * @generated from field: map<int32, bool> margin_call_timing = 9;
   */
  marginCallTiming: { [key: number]: boolean };

  /**
   * Collateral exchange model. UNSPECIFIED behaves as CALL_ONLY for backward
   * compatibility; callers should set it explicitly.
   *
   * @generated from field: devtool.emodel.v1.CSAType csa_type = 20;
   */
  csaType: CSAType;

  /**
   * Minimum Transfer Amount, pay side (JPY): gates eClear-side margin calls
   * (eClear posting to the customer). A call is skipped when the shortfall is
   * at or below this amount. Only used when csa_type = BILATERAL.
   *
   * @generated from field: optional double mta_pay = 22;
   */
  mtaPay?: number;

  /**
   * Minimum Transfer Amount, receive side (JPY): gates customer-side margin
   * calls (the customer posting to eClear, or refunds back). Only used when
   * csa_type = BILATERAL.
   *
   * @generated from field: optional double mta_receive = 23;
   */
  mtaReceive?: number;

  /**
   * Independent Amount held by eClear (JPY). Added to the bilateral transfer
   * target: target = previous-day exposure + independent_amount, so a positive
   * IA increases what eClear receives (and reduces what it posts). Only used
   * when csa_type = BILATERAL. Default (unset/0) disables it.
   *
   * Per the risk team's decision (2026-07), IA is kept as a config variable
   * but operationally fixed at 0 for now: the dynamic IA from the spec sheet
   * (forward-looking VM window) was rejected, and no caller sends a value yet.
   * The deposit-integrated BILATERAL model ignores it.
   *
   * @generated from field: optional double independent_amount = 24;
   */
  independentAmount?: number;

  /**
   * Initial Margin add-on (JPY) included in the customer's required margin
   * under the BILATERAL model, carried as a constant over the horizon.
   * Manual input for now (the IM engine wiring comes later).
   *
   * @generated from field: double initial_margin = 26;
   */
  initialMargin: number;

  /**
   * Base-date balance of customer deposits and guarantees held BY eClear
   * (eClear保有の顧客預託金＋保証残高, JPY). Only used when csa_type = BILATERAL.
   *
   * @generated from field: double clearer_held_deposit = 27;
   */
  clearerHeldDeposit: number;

  /**
   * Base-date balance of eClear deposits held BY the customer
   * (顧客保有のeClear預託金残高, JPY). Only used when csa_type = BILATERAL.
   *
   * @generated from field: double customer_held_deposit = 28;
   */
  customerHeldDeposit: number;

  /**
   * 統一エンジン（BILATERAL）の相互性パラメータ。true = 片務（顧客のみ差し入れ、
   * クオンツ統一証拠金エンジンの relationship_type=counterparty_only）：
   * eClear トラックは凍結、顧客側過不足は 0 フロア、余剰は withdrawal 経路で返却。
   * Only used when csa_type = BILATERAL.
   *
   * @generated from field: bool counterparty_only = 29;
   */
  counterpartyOnly: boolean;

  /**
   * ハイブリッドスキームの銀行保証枠（JPY）。顧客側マージンコールの発動判定・
   * 請求額のみを相殺し（預託金パスの目標 = 必要額 − 枠）、返却方向と
   * エクスポージャー系列には一切効かない（督促を待てるだけでリスクは減らない）。
   * Only used when csa_type = BILATERAL. 0 = なし。
   *
   * @generated from field: double standby_facility = 30;
   */
  standbyFacility: number;

  /**
   * 顧客預託金の余剰を返却するか。eClear 規約は「相手から求められない限り
   * 預かった担保を返却しない」なので、既定 false = 返却しない：顧客側の
   * 過不足は 0 フロアが強制され、返却経路（負のコール・withdrawal）は両方
   * 閉じる（顧客預託金は外生の入出金を除き単調非減少）。true で従来挙動：
   * 相互は負の不足額がそのまま返却（MTA が効く）、片務は withdrawal 経路で
   * 返却（MTA を通らない）。Only used when csa_type = BILATERAL.
   *
   * @generated from field: bool return_customer_collateral = 31;
   */
  returnCustomerCollateral: boolean;
};

/**
 * Describes the message devtool.emodel.v1.CollateralConfig.
 * Use `create(CollateralConfigSchema)` to create a new message.
 */
export const CollateralConfigSchema: GenMessage<CollateralConfig> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_common_model, 0);

/**
 * CollateralInfo reports which collateral settings were used after applying defaults.
 *
 * @generated from message devtool.emodel.v1.CollateralInfo
 */
export type CollateralInfo = Message<"devtool.emodel.v1.CollateralInfo"> & {
  /**
   * @generated from field: int64 threshold = 1;
   */
  threshold: bigint;

  /**
   * @generated from field: double current_collateral = 2;
   */
  currentCollateral: number;

  /**
   * @generated from field: devtool.emodel.v1.Frequency margin_call_frequency = 3;
   */
  marginCallFrequency: Frequency;

  /**
   * @generated from field: int32 payment_lag_days = 4;
   */
  paymentLagDays: number;

  /**
   * @generated from field: devtool.emodel.v1.BusinessDayConvention payment_convention = 5;
   */
  paymentConvention: BusinessDayConvention;

  /**
   * @generated from field: devtool.emodel.v1.Calendar payment_calendar = 6;
   */
  paymentCalendar: Calendar;
};

/**
 * Describes the message devtool.emodel.v1.CollateralInfo.
 * Use `create(CollateralInfoSchema)` to create a new message.
 */
export const CollateralInfoSchema: GenMessage<CollateralInfo> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_common_model, 1);

/**
 * FloatingIndexRef identifies a floating index reference (ORE FloatingLegData::index style).
 * Shared between MTM and PFE calculations.
 *
 * @generated from message devtool.emodel.v1.FloatingIndexRef
 */
export type FloatingIndexRef = Message<"devtool.emodel.v1.FloatingIndexRef"> & {
  /**
   * Index identifier (UUID or internal ID).
   *
   * @generated from field: string index_id = 1;
   */
  indexId: string;

  /**
   * Index code/name, e.g. "COMM-POWER_JP_TOKYO_BASE" (ORE FloatingIndex.name equivalent).
   *
   * @generated from field: string index_code = 2;
   */
  indexCode: string;
};

/**
 * Describes the message devtool.emodel.v1.FloatingIndexRef.
 * Use `create(FloatingIndexRefSchema)` to create a new message.
 */
export const FloatingIndexRefSchema: GenMessage<FloatingIndexRef> = /*@__PURE__*/
  messageDesc(file_devtool_emodel_v1_common_model, 2);

/**
 * BusinessDayConvention defines how to adjust dates that fall on non-business days.
 *
 * @generated from enum devtool.emodel.v1.BusinessDayConvention
 */
export enum BusinessDayConvention {
  /**
   * @generated from enum value: BUSINESS_DAY_CONVENTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BUSINESS_DAY_CONVENTION_FOLLOWING = 1;
   */
  FOLLOWING = 1,

  /**
   * @generated from enum value: BUSINESS_DAY_CONVENTION_MODIFIED_FOLLOWING = 2;
   */
  MODIFIED_FOLLOWING = 2,

  /**
   * @generated from enum value: BUSINESS_DAY_CONVENTION_PRECEDING = 3;
   */
  PRECEDING = 3,

  /**
   * @generated from enum value: BUSINESS_DAY_CONVENTION_UNADJUSTED = 4;
   */
  UNADJUSTED = 4,
}

/**
 * Describes the enum devtool.emodel.v1.BusinessDayConvention.
 */
export const BusinessDayConventionSchema: GenEnum<BusinessDayConvention> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_common_model, 0);

/**
 * Calendar defines business day rules. v0 currently treats weekends as holidays.
 *
 * @generated from enum devtool.emodel.v1.Calendar
 */
export enum Calendar {
  /**
   * @generated from enum value: CALENDAR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CALENDAR_JP = 1;
   */
  JP = 1,
}

/**
 * Describes the enum devtool.emodel.v1.Calendar.
 */
export const CalendarSchema: GenEnum<Calendar> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_common_model, 1);

/**
 * Frequency defines schedule frequency.
 *
 * @generated from enum devtool.emodel.v1.Frequency
 */
export enum Frequency {
  /**
   * @generated from enum value: FREQUENCY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FREQUENCY_DAILY = 1;
   */
  DAILY = 1,

  /**
   * @generated from enum value: FREQUENCY_WEEKLY = 2;
   */
  WEEKLY = 2,

  /**
   * @generated from enum value: FREQUENCY_MONTHLY = 3;
   */
  MONTHLY = 3,

  /**
   * @generated from enum value: FREQUENCY_QUARTERLY = 4;
   */
  QUARTERLY = 4,

  /**
   * @generated from enum value: FREQUENCY_SEMI_ANNUAL = 5;
   */
  SEMI_ANNUAL = 5,

  /**
   * @generated from enum value: FREQUENCY_ANNUAL = 6;
   */
  ANNUAL = 6,

  /**
   * @generated from enum value: FREQUENCY_BIWEEKLY = 7;
   */
  BIWEEKLY = 7,
}

/**
 * Describes the enum devtool.emodel.v1.Frequency.
 */
export const FrequencySchema: GenEnum<Frequency> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_common_model, 2);

/**
 * DayCounter defines day count convention for accrual calculations.
 *
 * @generated from enum devtool.emodel.v1.DayCounter
 */
export enum DayCounter {
  /**
   * @generated from enum value: DAY_COUNTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DAY_COUNTER_ACT_365F = 1;
   */
  ACT_365F = 1,

  /**
   * @generated from enum value: DAY_COUNTER_A_360 = 2;
   */
  A_360 = 2,

  /**
   * @generated from enum value: DAY_COUNTER_THIRTY_360 = 3;
   */
  THIRTY_360 = 3,
}

/**
 * Describes the enum devtool.emodel.v1.DayCounter.
 */
export const DayCounterSchema: GenEnum<DayCounter> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_common_model, 3);

/**
 * PayReceive indicates the direction of cashflows.
 *
 * @generated from enum devtool.emodel.v1.PayReceive
 */
export enum PayReceive {
  /**
   * @generated from enum value: PAY_RECEIVE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAY_RECEIVE_PAY = 1;
   */
  PAY = 1,

  /**
   * @generated from enum value: PAY_RECEIVE_RECEIVE = 2;
   */
  RECEIVE = 2,
}

/**
 * Describes the enum devtool.emodel.v1.PayReceive.
 */
export const PayReceiveSchema: GenEnum<PayReceive> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_common_model, 4);

/**
 * CSAType selects the collateral exchange model.
 *
 * @generated from enum devtool.emodel.v1.CSAType
 */
export enum CSAType {
  /**
   * Unspecified behaves as CALL_ONLY for backward compatibility.
   *
   * @generated from enum value: CSA_TYPE_UNSPECIFIED = 0;
   */
  CSA_TYPE_UNSPECIFIED = 0,

  /**
   * Deposit-integrated bilateral model (相互差し入れ＋預託金統合, Version 9.1):
   * both sides' deposit balances are tracked end-of-day. The customer must
   * cover max(MTM, 0) + initial_margin; eClear must cover max(-MTM, 0);
   * margin calls (gated only by the per-direction MTAs — there is no
   * threshold in this model) move the shortfall with a one-day settlement
   * lag, and the customer withdraws eClear-side surplus the day after a call
   * day. The collateral-adjusted PnL is
   * MTM - clearer_held_deposits + customer_held_deposits.
   *
   * @generated from enum value: CSA_TYPE_BILATERAL = 1;
   */
  CSA_TYPE_BILATERAL = 1,

  /**
   * Call only: eClear only receives collateral (the current production model).
   *
   * @generated from enum value: CSA_TYPE_CALL_ONLY = 2;
   */
  CSA_TYPE_CALL_ONLY = 2,
}

/**
 * Describes the enum devtool.emodel.v1.CSAType.
 */
export const CSATypeSchema: GenEnum<CSAType> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_common_model, 5);

/**
 * AreaCode identifies one of the nine Japanese power delivery areas.
 *
 * The value numbers and names are intentionally identical to ePosition's
 * types.v1.AreaCode, which this enum replaced so that eModel's API stops
 * depending on the caller's type vocabulary. Enum numbers travel on the wire,
 * so the two are binary- and protojson-compatible: keep them in sync when
 * either side gains an area.
 *
 * @generated from enum devtool.emodel.v1.AreaCode
 */
export enum AreaCode {
  /**
   * @generated from enum value: AREA_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 北海道
   *
   * @generated from enum value: AREA_CODE_HOKKAIDO = 1;
   */
  HOKKAIDO = 1,

  /**
   * 東北
   *
   * @generated from enum value: AREA_CODE_TOHOKU = 2;
   */
  TOHOKU = 2,

  /**
   * 東京
   *
   * @generated from enum value: AREA_CODE_TOKYO = 3;
   */
  TOKYO = 3,

  /**
   * 中部
   *
   * @generated from enum value: AREA_CODE_CHUBU = 4;
   */
  CHUBU = 4,

  /**
   * 北陸
   *
   * @generated from enum value: AREA_CODE_HOKURIKU = 5;
   */
  HOKURIKU = 5,

  /**
   * 関西
   *
   * @generated from enum value: AREA_CODE_KANSAI = 6;
   */
  KANSAI = 6,

  /**
   * 中国
   *
   * @generated from enum value: AREA_CODE_CHUGOKU = 7;
   */
  CHUGOKU = 7,

  /**
   * 四国
   *
   * @generated from enum value: AREA_CODE_SHIKOKU = 8;
   */
  SHIKOKU = 8,

  /**
   * 九州
   *
   * @generated from enum value: AREA_CODE_KYUSHU = 9;
   */
  KYUSHU = 9,
}

/**
 * Describes the enum devtool.emodel.v1.AreaCode.
 */
export const AreaCodeSchema: GenEnum<AreaCode> = /*@__PURE__*/
  enumDesc(file_devtool_emodel_v1_common_model, 6);

